<template>
	<div
		id="matchday-wrapper"
		class="list--wrapper-container"
	>
		<Matchday
			:tabs="tabs"
			:columns="columns"
			:events="matchdayEvents"
			:teams="teams"
			:board="board"
			:event-league="eventLeague"
			:no-events-today="noEventsToday"
			:is-matchday-loading="isMatchdayLoading"
			:show-league-header="showLeagueHeader"
			@redirect-to-upcoming-event="handleRedirectToUpcomingEvent"
		/>
	</div>
</template>

<script>
import laroute from '@laroute';
import Matchday from '@components/Matchday';
import { mapGetters, mapActions } from 'vuex';

export default {
	name:       'MatchdayBlock',
	components: { Matchday },
	props:      {
		showLeagueHeader: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
	  		isMatchdayLoading: false,
		};
	},
	computed: {
		...mapGetters({
			event:          'event/event',
			participants:   'event/participants',
			leagueTable:    'event/leagueTable',
			eventLeague:    'event/league',
			matchdayEvents: 'event/matchdayEvents',
		}),
		noEventsToday() {
			return this.$I18n.trans('view_mode.no_events_today');
		},
		tabs() {
			const tabs = [
				{
					id:    0,
					label: this.transChoiceUcFirst('commons.event', 2),
					key:   'tab-0',
				},
			];
			if (this.leagueTable?.entries?.data?.length > 0) {
				tabs.push({
					id:    1,
					label: this.$I18n.trans('view_mode.table'),
					key:   'tab-1',
				});
			}
			return tabs;
		},
		sportsLeagueTrans() {
			return this.$I18n.trans('sports.league');
		},
		columns() {
			return [
				{
					label: this.$Helpers.ucfirst(this.$I18n.trans_choice('commons.club', 1)),
				},
				{
					label: this.getSportLeagueTransProp('games'),
				},
				{
					label: this.getSportLeagueTransProp('gamesWon'),
				},
				{
					label: this.getSportLeagueTransProp('gamesDraw'),
				},
				{
					label: this.getSportLeagueTransProp('gamesLost'),
				},
				{
					label: this.getSportLeagueTransProp('points'),
				},
			];
		},
		teams() {
			return {
				teamHome:  this.participants[0],
				teamGuest: this.participants[1],
			};
		},
		board() {
			if (this.leagueTable) {
				const board = [];
				const entries = this.leagueTable.entries;
				for (const entry of entries.data) {
					const boardEntry = {};
					boardEntry.id = entry.id;
					boardEntry.team = { ...entry.team, position: entry.rank };
					boardEntry.stats = [
						{
							id:    1,
							label: this.getSportLeagueTransProp('games'),
							value: entry.data.games,
						},
						{
							id:    2,
							label: this.getSportLeagueTransProp('gamesWon'),
							value: entry.data.gamesWon,
						},
						{
							id:    3,
							label: this.getSportLeagueTransProp('gamesDraw'),
							value: entry.data.gamesDraw,
						},
						{
							id:    4,
							label: this.getSportLeagueTransProp('gamesLost'),
							value: entry.data.gamesLost,
						},
						{
							id:    5,
							label: this.getSportLeagueTransProp('points'),
							value: entry.data.points,
						},
					];
					board.push(boardEntry);
				}
				return board;
			} else {
				return [];
			}
		},
	},
	async mounted() {
		await this.loadMatchdayEvents();
	},
	methods: {
		...mapActions({
			_loadMatchdayEvents: 'event/loadMatchdayEvents',
		}),
		handleRedirectToUpcomingEvent(event) {
			const newPath = laroute.route('arena.event', { event: event.id });
			window.location.replace(newPath + window.location.search);
		},
		getSportLeagueTransProp(prop) {
			if (this.sportsLeagueTrans && this.sportsLeagueTrans[prop]) {
				return this.sportsLeagueTrans[prop].abbr;
			}
		},
		async loadMatchdayEvents() {
			if (this.matchdayEvents.length) {
				return;
			}
			try {
				this.isMatchdayLoading = true;
				await this._loadMatchdayEvents(true);
			} finally {
				this.isMatchdayLoading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
#matchday-wrapper {
	height: 100%;
}
</style>
